var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBeelajarGridOnSharp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.175 15.844V19.5H4.5V15.844H8.175ZM13.825 15.844V19.5H10.175V15.844H13.825ZM19.5 15.844V19.5H15.825V15.844H19.5ZM8.175 10.156V13.844H4.5V10.156H8.175ZM13.825 10.156V13.844H10.175V10.156H13.825ZM19.5 10.156V13.844H15.825V10.156H19.5ZM8.175 4.5V8.156H4.5V4.5H8.175ZM13.825 4.5V8.156H10.175V4.5H13.825ZM19.5 4.5V8.156H15.825V4.5H19.5Z",
    fill: "#7B2183",
    stroke: "#7B2183"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBeelajarGridOnSharp);
export default __webpack_public_path__ + "static/media/ic_beelajar_grid-on-sharp.31edc0241b2a787add6b72098109c9a7.svg";
export { ForwardRef as ReactComponent };